<template>
  <div class="margin-top-20">
    <textarea :id="id" name="content" v-model="outContent"></textarea>
    <input
      @change="selectedFile"
      :action="dataPath"
      accept="mp4,video/*, image/gif, image/jpeg, image/jpg, image/png, image/svg"
      style="visibility: hidden;height:0;"
      type="file"
      name
      id="inputFile"
    />
  </div>
</template>
<script>
import axios from 'axios'
// import 'kindeditor/themes/default/default.css'
// import 'kindeditor/kindeditor-all-min.js'
// import 'kindeditor/lang/zh-CN.js'

export default {
  name: 'kindeditor-component',
  props: {
    // 编辑器内容 url
    html: {
      type: String,
      default: ''
    },
    // 编辑器内容
    content: {
      type: String,
      default: ''
    },
    // 编辑器id
    id: {
      type: String,
      // required: true,
      default: 'kindeditor-id'
    },
    // 宽
    width: {
      type: String,
      default: `100%`
    },
    // 高
    height: {
      type: String,
      default: '400'
    },
    // 最小宽
    minWidth: {
      type: Number,
      default: 650
    },
    // 最小高
    minHeight: {
      type: Number,
      default: 400
    },
    // toolbar 工具栏配置
      items: {
      type: Array,
      default: function() {
        return [
        //   "source",
        //   "|",
          "undo",
          "redo",
          "|",
          "preview",
          "print",
          "template",
          "code",
          "cut",
          "copy",
          "paste",
          "plainpaste",
          "wordpaste",
          "|",
          "justifyleft",
          "justifycenter",
          "justifyright",
          "justifyfull",
          "insertorderedlist",
          "insertunorderedlist",
          "indent",
          "outdent",
          "subscript",
          "superscript",
          "clearhtml",
          "quickformat",
          "selectall",
          "|",
          "fullscreen",
          "/",
          "formatblock",
          "fontname",
          "fontsize",
          "|",
          "forecolor",
          "hilitecolor",
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "lineheight",
          "removeformat",
          "|",
          "image",
          //"multiimage",
          //"flash",
          //"media",
          //"insertfile",
          "table",
          "hr",
          // "emoticons",
        //   "baidumap",
          "pagebreak",
          "anchor",
          "link",
          "unlink",
          "|",
        //   "about"
        ];
      }
    },
    // 标签配置
    htmlTags: {
      type: Object,
      default: function() {
        return {
          font: ["color", "size", "face", ".background-color"],
          span: ["style"],
          div: ["class", "align", "style"],
          table: [
            "class",
            "border",
            "cellspacing",
            "cellpadding",
            "width",
            "height",
            "align",
            "style"
          ],
          "td,th": [
            "class",
            "align",
            "valign",
            "width",
            "height",
            "colspan",
            "rowspan",
            "bgcolor",
            "style"
          ],
          a: ["class", "href", "target", "name", "style"],
          embed: [
            "src",
            "width",
            "height",
            "type",
            "loop",
            "autostart",
            "quality",
            "style",
            "align",
            "allowscriptaccess",
            "/"
          ],
          img: [
            "src",
            "width",
            "height",
            "border",
            "alt",
            "title",
            "align",
            "style",
            "/"
          ],
          hr: ["class", "/"],
          br: ["/"],
          "p,ol,ul,li,blockquote,h1,h2,h3,h4,h5,h6": ["align", "style"],
          "tbody,tr,strong,b,sub,sup,em,i,u,strike": []
        };
      }
    },
    // 字号配置
     fontSizeTable: {
      type: Array,
      default: function() {
        return [
          "9px",
          "10px",
          "12px",
          "14px",
          "16px",
          "18px",
          "24px",
          "32px",
          "34px",
          "36px",
          "38px",
          "40px"
        ];
      }
    },
    // 语言配置
    langType: {
      type: String,
      default: 'zh-CN'
    },
    // 主题配置
    themeType: {
      type: String,
      default: 'default'
    },
    // body 的样式
    bodyClass: {
      type: String,
      default: 'ke-content'
    },
    // 其他配置项
    // ...otherConfig
  },
  data() {
    return {
      editor: null,
      outContent: this.content,
      // outContent: "",
      editor: "",
      path: "",
    }
  },

  watch: {
    content(val) {
      // console.log(99,val)
      // this.editor && val !==  this.editor.html(val)
      // this.editor.txt.html(val);
      // this.outContent = val;
      this.editor && val !== this.outContent && this.editor.html(val);
 
    },
    // 分发编辑器内容改变事件
    outContent(val) {
      this.$emit('update:content', val)
      this.$emit('on-content-change', val)
      this.$emit('input', val)
    },
    // 初始化编辑器内容
    // html(val) {
    //   console.log(2222,val)
    //   if (
    //     this.html &&
    //     (this.html.startsWith('https://') || this.html.startsWith('http://'))
    //   ) {
    //     this.loadUrl(val)
    //   } else {
    //     this.outContent = ''
    //     this.outContent ? this.editor.appendHtml(this.outContent) : ''
    //   }
    // }
  },
  // created() {
  //   if (
  //     this.html &&
  //     (this.html.startsWith('https://') || this.html.startsWith('http://'))
  //   ) {
  //     this.loadUrl(this.html)
  //   } else {
  //     this.outContent = ''
  //     setTimeout(() => {
  //       this.outContent ? this.editor.appendHtml(this.outContent) : ''
  //     }, 1000)
  //   }
  // },
  mounted() {
    this.path = localStorage.getItem("urlcode");
    // 初始访问时创建
    this.initEditor()
    //  添加焦点
    // this.editor.focus();
    // 添加点击图片回调函数
    this.editor.clickToolbar('image', () => {
      // 禁用自带的图片弹窗
      this.editor.hideDialog()
      // 打开文件
      this.handleOpenFile()
    })
  },
   computed: {
    dataPath() {
      this.path = localStorage.getItem("urlcode");
      let text = `${this.path}/api/qiniu/upload/prefix`;
      return text;
    },
   },
  methods: {
    //  getContent: function () {
    //   return this.editorContent;
    // },
    // setContent: function (text) {
    //   this.editor.txt.html(`${text}`);
    // },
    // getUptext() {
    //   return this.editor.txt.html();
    // },
    // uploadimg() {
    //   this.$refs.input.click();
    // },
    // 打开文件
    handleOpenFile() {
      const input = document.getElementById('inputFile')
      // 解决同一个文件不能监听的问题
      input.addEventListener(
        'click',
        function() {
          this.value = ''
        },
        false
      )
      // 点击input
      input.click()
    },
     
    // 选择好文件
    selectedFile($event) { 
      // console.log(3333,$event)
      let file = $event.target.files[0]
      let formData = new FormData(); // 创建一个form类型的数据
      formData.append("file", file);
      // console.log(999,this.formData)
      this.path = localStorage.getItem("urlcode");
      let text = `${this.path}/api/qiniu/upload/prefix`;
      let _this = this;
      axios({
        url: text,
        method: 'post',
        async: false,
        processData: false, // 将数据转换成对象，不对数据做处理，故 processData: false
        contentType: false, // 不设置数据类型
        data: formData,
      }).then((res) => {
        // console.log(1234,res)
          let url = res.data.result.url;
          _this.editor.appendHtml(
            '<img src="' + url + '" alt="" >'
          );
      }
    )
    },
    // 编辑器内容上传到cos，调用返回url
    async content2Url() {
      // 把html片段上传到后端服务器 拿到url  uploadHtml 是自己后端上传的接口
        try {
          const res = await uploadHtml(this.outContent)
          return res
        } catch (error) {
          this.message({
            message: error.data.message,
            type: 'error'
          })
        }
    },
    // 加载html填充编辑器内容
    loadUrl(url) {
      // console.log(44,url)
      if (url && url.length > 0) {
        axios
          .get(url)
          .then(response => {
            // 处理HTML显示
            this.outContent = response.data
            this.editor.appendHtml(this.outContent)
            this.$emit('subLoadUrlToHtml', response.data)
          })
          .catch(() => {
            this.outContent = '服务器数据加载失败，请重试!'
            this.editor.appendHtml(this.outContent)
          })
      }
    },
    // 移除编辑器实例
    removeEditor() {
      window.KindEditor.remove(`#${this.id}`)
    },
    // 初始化编辑器
    initEditor() {
      this.removeEditor()
      this.editor = window.KindEditor.create('#' + this.id, {
        width: this.width,
        height: this.height,
        minWidth: this.minWidth,
        minHeight: this.minHeight,
        items: this.items,
        noDisableItems: this.noDisableItems,
        filterMode: this.filterMode,
        htmlTags: this.htmlTags,
        wellFormatMode: this.wellFormatMode,
        resizeType: this.resizeType,
        themeType: this.themeType,
        langType: this.langType,
        designMode: this.designMode,
        fullscreenMode: this.fullscreenMode,
        basePath: this.basePath,
        themesPath: this.themesPath,
        pluginsPath: this.pluginsPath,
        langPath: this.langPath,
        minChangeSize: this.minChangeSize,
        loadStyleMode: this.loadStyleMode,
        urlType: this.urlType,
        newlineTag: this.newlineTag,
        pasteType: this.pasteType,
        dialogAlignType: this.dialogAlignType,
        shadowMode: this.shadowMode,
        zIndex: this.zIndex,
        useContextmenu: this.useContextmenu,
        syncType: this.syncType,
        indentChar: this.indentChar,
        cssPath: this.cssPath,
        cssData: this.cssData,
        bodyClass: this.bodyClass,
        colorTable: this.colorTable,
        afterCreate: this.afterCreate,
        // 编辑器内容改变回调
        afterChange: () => {
          this.editor ? (this.outContent = this.editor.html()) : ''
        },
        afterTab: this.afterTab,
        afterFocus: this.afterFocus,
        afterBlur: this.afterBlur,
        afterUpload: this.afterUpload,
        uploadJson: this.uploadJson,
        fileManagerJson: this.fileManagerJson,
        allowPreviewEmoticons: this.allowPreviewEmoticons,
        allowImageUpload: this.allowImageUpload,
        allowFlashUpload: this.allowFlashUpload,
        allowMediaUpload: this.allowMediaUpload,
        allowFileUpload: this.allowFileUpload,
        allowFileManager: this.allowFileManager,
        fontSizeTable: this.fontSizeTable,
        imageTabIndex: this.imageTabIndex,
        formatUploadUrl: this.formatUploadUrl,
        fullscreenShortcut: this.fullscreenShortcut,
        extraFileUploadParams: this.extraFileUploadParams,
        filePostName: this.filePostName,
        fillDescAfterUploadImage: this.fillDescAfterUploadImage,
        afterSelectFile: this.afterSelectFile,
        pagebreakHtml: this.pagebreakHtml,
        allowImageRemote: this.allowImageRemote,
        autoHeightMode: this.autoHeightMode,
        fixToolBar: this.fixToolBar,
        tabIndex: this.tabIndex
      })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/index.vue